import script from "./OrderDetailsDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrderDetailsDialog.vue?vue&type=script&lang=ts&setup=true"

import "./OrderDetailsDialog.vue?vue&type=style&index=0&id=264bcfd6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-264bcfd6"]])

export default __exports__